import { getState } from './state';
import { createSelector } from 'reselect';

export const getMessageState = createSelector(
  [state => getState(state).messageState ?? {}, (state, messageId: string) => messageId],
  (messageState, messageId) => {
    return messageState[messageId] || {};
  }
);
